type DiscountInput = {
  price: number
  compareAtPrice: number
  discountPercentage?: string | number | null
}

export const calculateDiscountPercentage = ({
  price,
  compareAtPrice,
  discountPercentage,
}: DiscountInput): number => {
  if (discountPercentage != null && discountPercentage !== '') {
    return Math.round(Number(discountPercentage))
  }

  if (compareAtPrice <= 0 || compareAtPrice <= price) {
    return 0
  }

  return Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
}
